import requester from './serverRequest.js';
const serverApi = {
  /**
   * csrfTokenGet request.
   *
   * @returns {Promise}
   */
  csrfTokenGet: function csrfTokenGet() {
    return requester.request({
      url: '/csrf-token',
      method: 'get',
    });
  },

  /**
   * ticketApproveById request.
   *
   * @param {number} lookID
   * @returns {Promise<{}>}
   */
  ticketApproveById: function ticketApproveById(lookID) {
    return serverApi.csrfTokenGet().then(function afterCsrfTokenSet(response) {
      const csrfToken = response.data.token;
      return requester.request({
        url: `/looks/${lookID}/approve`,
        method: 'post',
        headers: {
          'X-CSRF-Token': csrfToken
        }
      });
    });
  },

  /**
   * ticketGetById request.
   *
   * @param {number} lookID
   * @returns {Promise<{}>}
   */
  ticketGetById: function ticketGetById(lookID) {
    return requester.request({
      url: `/looks/${lookID}`,
      method: 'get',
    });
  },

  /**
   * ticketUpdateById request.
   *
   * @param {number} lookID
   * @param {string} changeRequest
   * @returns {Promise<{}>}
   */
  ticketUpdateById: function ticketUpdateById(lookID, changeRequest) {
    return serverApi.csrfTokenGet().then(function afterCsrfTokenSet(response) {
      const csrfToken = response.data.token;
      return requester.request({
        url: `/looks/${lookID}`,
        method: 'post',
        data: {
          changeRequest,
        },
        headers: {
          'X-CSRF-Token': csrfToken
        }
      });
    });
  },

  /**
   * lookVerifyById request.
   *
   * @param {string} dataType
   * @param {string} value
   * @param {string} lookID
   * @returns {Promise<{}>}
   */
  lookVerifyById: function lookVerifyById(dataType, value, lookID) {
    return serverApi.csrfTokenGet().then(function afterCsrfTokenSet(response) {
      const csrfToken = response.data.token;
      return requester.request({
        url: `/looks/${lookID}/verify`,
        method: 'post',
        data: {
          dataType,
          value,
          lookID
        },
        headers: {
          'X-CSRF-Token': csrfToken
        }

      });
    });
  },

};

export default serverApi;



// WEBPACK FOOTER //
// ./src/utils/serverApi.js